import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import AiIcon from '../assets/ai/AiIcon';
import AiHeader from './AiHeader';
import ChatInput from './ChatInput';
import useAiTutor from './hooks';
import MessageBox from './MessageBox';
import WelcomeBubble from './WelcomeBubble';

const mountedStyle = { animation: 'slideIn 250ms ease-in' };
const unmountedStyle = { animation: 'slideOut 270ms ease-out', animationFillMode: 'forwards' };

const AiTutorMobile = ({ courseId, pendingMessage, onPendingMessageConsumed }) => {
  // prettier-ignore
  const {
    isOpen, showDiv, messages, isSending, sendMessage, toggleOpen, chatEndRef,
  } = useAiTutor(courseId);

  useEffect(() => {
    if (!pendingMessage) return;
    if (!isOpen) toggleOpen();
    const formData = new FormData();
    formData.append('message', pendingMessage);
    sendMessage(formData);
    onPendingMessageConsumed();
  }, [pendingMessage]); // eslint-disable-line react-hooks/exhaustive-deps

  const [showWelcomeBubble, setShowWelcomeBubble] = useState(false);
  const [isClosingBubble, setIsClosingBubble] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcomeBubble(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const handleIconClick = () => {
    setIsClosingBubble(true);
    setTimeout(() => {
      setShowWelcomeBubble(false);
      setIsClosingBubble(false);
      toggleOpen();
    }, 600);
  };

  const handleCloseBubble = () => {
    setIsClosingBubble(true);
    setTimeout(() => {
      setShowWelcomeBubble(false);
      setIsClosingBubble(false);
    }, 600);
  };

  return (
    <>
      {showDiv && (
        <div
          className="ai-tutor h-tw-h-screen tw-fixed tw-inset-0 tw-z-50 tw-flex tw-w-screen tw-flex-col tw-bg-white tw-shadow-lg"
          style={isOpen ? mountedStyle : unmountedStyle}
        >
          <AiHeader mobile handleClose={toggleOpen} />
          <MessageBox
            queryData={messages}
            isLoading={isSending}
            chatEndRef={chatEndRef}
            isExpanded={false}
            sendMessage={sendMessage}
          />
          <ChatInput mutate={sendMessage} className="tw-mt-auto" />
        </div>
      )}

      <div
        className={`tw-fixed tw-bottom-0 tw-right-0 tw-z-50 tw-mb-8 tw-mr-4 tw-flex tw-items-end ${showWelcomeBubble ? 'tw-flex-row tw-gap-3' : 'tw-flex-col'}`}
      >
        {!showDiv && showWelcomeBubble && (
          <WelcomeBubble
            isClosing={isClosingBubble}
            onClose={handleCloseBubble}
            onClick={handleIconClick}
          />
        )}

        <button
          type="button"
          onClick={handleIconClick}
          className={`ai-button tw-relative ${isOpen ? 'toggle-open' : 'toggle-close'}`}
        >
          {!showDiv && (
            <>
              <AiIcon className="ai-pulse" width={64} height={64} />
              {showWelcomeBubble && !isClosingBubble && (
                <span className="tw-absolute -tw-right-1 -tw-top-1 tw-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-full tw-bg-mainPurple tw-text-[14px] tw-font-medium tw-text-white">
                  1
                </span>
              )}
            </>
          )}
        </button>
      </div>
    </>
  );
};

AiTutorMobile.propTypes = {
  courseId: PropTypes.string.isRequired,
  pendingMessage: PropTypes.string,
  onPendingMessageConsumed: PropTypes.func,
};

AiTutorMobile.defaultProps = {
  pendingMessage: '',
  onPendingMessageConsumed: () => {},
};

export default AiTutorMobile;
